/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-10 16:58:23
 * @LastEditTime: 2022-01-12 14:39:58
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 数币对账单 - 汇总数据订单详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/SZRMBList/components/SzRmbPayOrderSummaryDataOrderDetailModal.jsx
 */
import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchPlatformRecordSzRmbPayOrderSummaryDataGet } from '../../../../services/platformAccountingRecord';
import { formatTime } from '../../../../utils';

const SzRmbPayOrderSummaryDataOrderDetail = (props) => {

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postSzRmbPayOrderSummaryDataGet(id)
    }
    const close = () => {
        setVisible(false)
    }
    const postSzRmbPayOrderSummaryDataGet = (id) => {
        setLoading(true)
        fetchPlatformRecordSzRmbPayOrderSummaryDataGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false) 
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="数币对账单详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow >
                        <CustomCol label="银行流水号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.bankSerialNumber}</span>
                        </CustomCol>
                        <CustomCol label="记账日期">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.bookkeepingDate, 'YYYY-MM-DD')}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="柜台代码">
                            <span style={{ paddingLeft:6 }}>{detailData.counterCode}</span>
                        </CustomCol>
                        <CustomCol label="汇总数据ID">
                            <span style={{ paddingLeft:6 }}>{detailData.summaryDataId}</span>
                        </CustomCol>
                        <CustomCol label="商户集团号">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantGroupNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="创建时间">
                            <span style={{ paddingLeft:6 }}>{detailData.createTime}</span>
                        </CustomCol>
                        <CustomCol label="发卡行/通道">
                            <span style={{ paddingLeft:6 }}>{detailData.issuer}</span>
                        </CustomCol>
                        <CustomCol label="清算金额">
                            <span style={{ paddingLeft:6 }}>{detailData.liquidationAmount}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="订单信息" />
                    <CustomRow divider>
                        <CustomCol label="订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.orderNo}</span>
                        </CustomCol>
                        <CustomCol label="订单金额">
                            <span style={{ paddingLeft:6 }}>{detailData.orderAmount}</span>
                        </CustomCol>
                       
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="商户订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.merchantOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="订单状态">
                            <span style={{ paddingLeft:6 }}>{detailData.orderStatus}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        
                        <CustomCol label="支付卡种">
                            <span style={{ paddingLeft:6 }}>{detailData.paymentCardType}</span>
                        </CustomCol>
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeAmount}</span>
                        </CustomCol>
                        <CustomCol label="手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.serviceCharge}</span>
                        </CustomCol>
                    </CustomRow>
              
               
                    <CustomRow divider>
                        <CustomCol label="付款方户名">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeCardName}</span>
                        </CustomCol>
                        <CustomCol label="付款方账号">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeCardNumber}</span>
                        </CustomCol>
                        <CustomCol label="交易时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.tradeDateTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易类型">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeType}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default SzRmbPayOrderSummaryDataOrderDetail


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/SZRMBList/components/SzRmbPayOrderSummaryDataOrderDetailModal.jsx